import { Box, Button, Typography } from "@mui/material";
import { useImpersonation } from "../../hooks/useImpersonation";

export const BANNER_HEIGHT = 44;

const BANNER_BG = "#fcc203";
const BANNER_FG = "#1a1a1a";

function formatTime(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

export default function ImpersonationOverlay() {
  const { isImpersonating, context, exit, timeRemaining } = useImpersonation();

  if (!isImpersonating || !context) return null;

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: BANNER_HEIGHT,
          bgcolor: BANNER_BG,
          color: BANNER_FG,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          zIndex: 9999,
          px: 2,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          You are viewing as: {context.targetOrgName}
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.88 }}>
          ({formatTime(timeRemaining)} remaining)
        </Typography>
        <Button
          variant="contained"
          size="small"
          onClick={() => void exit()}
          sx={{
            bgcolor: BANNER_FG,
            color: BANNER_BG,
            fontWeight: 700,
            textTransform: "none",
            "&:hover": { bgcolor: "#333" },
            ml: 1,
          }}
        >
          Stop Viewing
        </Button>
      </Box>

      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: `3px solid ${BANNER_BG}`,
          pointerEvents: "none",
          zIndex: 9998,
        }}
      />

      <Box sx={{ height: BANNER_HEIGHT }} />
    </>
  );
}
